import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V6AnnArrivedAfter } from "./V6";
import { doDoorRing, doTransition, doWaitImageByTime } from "../helpers/helpers";


export const V6AnnArrived = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_0);
    doDoorRing();
    mc.think(`I'm coming... Give me a second.`);
    mc.think(`Is that... Ann?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_1);
    mc.talk(`Hey Ann!`);
    ann.talk(`${mc.name}! I've missed you.`);
    ann.talk(`I hope I'm not disturbing... Maybe I should have called.`);
    mc.talk(`Not at all!`);
    mc.talk(`Come in.`);
    ann.talk(`Ok! Hehe.`);


    return jump(V6AnnArrivedLivingRoom, "V6AnnArrivedLivingRoom");
};


export const V6AnnArrivedLivingRoom = async (): Promise<any> => {
    doTransition(images.v6.AnnArrivedNewOutfit_2);
    mc.talk(`So, how are you?`);
    ann.talk(`I'm great! I figured I'd drop by since I was headed to the library, hehe.`);
    mc.talk(`Oh, that's nice.`, { style: { overlay: true } });
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_2);

    if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Face`)) {
        mc.talk(`You know... You didn't look too pleased when I left yesterday.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_6);
        ann.talk(`Oh yeah...`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`Well I was just surprised that you did that... On my face... I didn't know how to react.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        ann.talk(`I already said that if you like it we can do it again...`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`Once you left I had some time to think, and it wasn't bad at all... I was just surprised that's all.`);

    } else {

    }
    if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Belly`)) {
        mc.talk(`By the way... We didn't have time to talk yesterday, I hope you had fun.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`Hehe, you know I did! I already said that yesterday, dummy.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15);
        ann.talk(`I read that it won't hurt so much the second time.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_3);
        mc.talk(`We can go to my room right now.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_6);
        ann.talk(`Ah... It could be nice but... I need to go study...`);
        mc.talk(`You owe me!`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_3);
        ann.talk(`Sure, hehe.`);
    } else {

    }
    if (mc.properties.joeStatus === "enemy") {
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`Anyway... I know that's not my business but I was wondering if you and Joey happened to talk since... You know.`);

        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        mc.talk(`Not really. I don't think he wants anything to do with me.`);

        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15);
        ann.talk(`It makes me feel so sad to hear that.`);
        ann.talk(`I haven't known you both for that long, but when I heard about your relationship from Vanessa I got excited and wanted to see what great friends you were.`);
        ann.talk(`Did that makes sense? I hope it didn't sound stupid.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        mc.talk(`No, I understand.\nBut that's the reality right now.`);

        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`I can talk to him if you want.`);
        return jump(V6AnnArrivedLivingRoom_Question, "V6AnnArrivedLivingRoom_Question");

    } else {

    }
    return jump(V6AnnArrivedLivingRoom_2, "V6AnnArrivedLivingRoom_2");



};

export const V6AnnArrivedLivingRoom_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    await ann.setQuestion(new Question({ text: `I won't say that you sent me or anything! I'll just try to settle things down.\nWhat do you say?`, options: { think: false }, key: `v6LetAnnTryToMakePeaceWithJoe` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v6LetAnnTryToMakePeaceWithJoe) {
        return jump(V6AnnArrivedLivingRoom_Question_Agree, "V6AnnArrivedLivingRoom_Question_Agree");

    } else {
        return jump(V6AnnArrivedLivingRoom_Question_Disagree, "V6AnnArrivedLivingRoom_Question_Disagree");

    }

};

export const V6AnnArrivedLivingRoom_Question_Agree = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`You know what? Why not.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_3);
    ann.talk(`Really???`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`Yeah... He is my best friend... I miss our talks.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`I'm glad I asked! I'll think of something.`);
    return jump(V6AnnArrivedLivingRoom_2, "V6AnnArrivedLivingRoom_2");
};


export const V6AnnArrivedLivingRoom_Question_Disagree = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`Nah. Leave him be.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Are you sure?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`Positive.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Ok... Like I said... It makes me sad, but ok. I won't do anything against your will.`);
    ann.talk(`Can I ask why?`);
    if (mc.properties.alpha >= 7) {
        mc.talk(`Ann. I said no. Now stop talking about it.`);
        ann.talk(`Ok ok, sorry.`);
    } else {
        mc.talk(`I'm just don't think it's the right time.`);
        ann.talk(`Ok... I can respect that.`);
        ann.talk(`Just tell me when you are ready for me to help out and I'll do it. Ok?`);
        mc.talk(`Sure.`);
    }

    return jump(V6AnnArrivedLivingRoom_2, "V6AnnArrivedLivingRoom_2");
};

export const V6AnnArrivedLivingRoom_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);

    ann.talk(`Oh! I almost forgot! Did Vanessa talk to you?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`When?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Today.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`No, she haven't. I woke up ten seconds before you knocked on the door.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Oh.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`She is planning something at her place today.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);

    if (mc.properties.joeStatus === "enemy") {
        mc.talk(`I don't think I'm invited.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);

        if (Question.globalAnswers.v1EnableNTR) {
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Oh... You'd be surprised.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`What's that supposed to mean?`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`She kinda insisted on you being there.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`Really? Why me?`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`She didn't say. She just told me to convince you in any way possible to be there.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`Weird... She must be planning something.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Yeah... I think so as well.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`Are you gonna go?`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Yeah, why not? What's the worst she can do?`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`Yeah, that's true.`);
            mc.talk(`Alright, tell her that I'll be there.`);
        } else {
            ann.talk(`Don't be silly! Of course you are!`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`After all that has happened? I doubt it.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`She knows that if you won't come I wouldn't either.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`...`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Please! It's gonna be for the best!`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`I guess Joe is gonna be there.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Yeah...`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`I don't know about that.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
            ann.talk(`Do it for me! Please! If you feel uncomfortable we'll just leave together.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
            mc.talk(`Fine.`);
            ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        }
    } else {
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        mc.talk(`Really? Why?`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`I don't know, she said she missed having all four of us sitting together and talking.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        mc.talk(`We basically did it a few days ago.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`I know... Tell that to her.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        mc.talk(`Nah... Haha.`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
        ann.talk(`Yeah... That's what I told myself as well.`);
        ann.talk(`So? Are you gonna come?`);
        ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
        mc.talk(`Yeah... Why not? I don't have any plans.`);
    }

    ann.talk(`Yay!`);
    return jump(V6AnnArrivedLivingRoom_EmilyJoined, "V6AnnArrivedLivingRoom_EmilyJoined");
};

export const V6AnnArrivedLivingRoom_EmilyJoined = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_7, { duration: 0.6, transition: true });
    emily.talk(`${mc.name}, I heard the doorbell.`);
    mc.talk(`Emily, meet Ann.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_8);
    emily.talk(`Ann! I've heard about you! You are ${mc.name}'s girlfriend!`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_9);
    ann.talk(`I am...`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_10);
    ann.talk(`I don't think he mentioned you...`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_8);
    ann.talk(`Who are you?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_11);
    emily.talk(`He didn't? That's rude.\nI'm his ${emily.properties.relation}!`);
    ann.talk(`Oh. Nice to meet you.`);
    emily.talk(`You know. ${mc.name} said only good things about you!`);
    ann.talk(`Yeah...`);
    ann.talk(`Can I ask you a question?`);
    emily.talk(`Sure!`);
    ann.talk(`Do you always walk around the house like that...?`);
    emily.talk(`Only when the air conditioner in my room gets broken.`);
    emily.talk(`And believe me, it happens A LOT.`);
    emily.talk(`Why do you ask? Because of ${mc.name}?`);
    emily.talk(`We grew up together, he doesn't mind.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_12);
    emily.talk(`Right?`);
    mc.talk(`I don't.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_11);
    ann.talk(`Oh... Hehe. If you say so.`);

    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_12);
    emily.talk(`Anyway, ${mc.name}, I was wondering if you have any plans.`);
    mc.talk(`I'm not sure, Ann said that she wants us to go to Vanessa's house.`);
    emily.talk(`Vanessa? Joey's girlfriend?`);
    mc.talk(`Yeah.`);
    if (mc.properties.joeStatus === "enemy") {

        emily.talk(`Oh great! So you and Joey are friends again!`);
        mc.talk(`Not really... Long story.`);
    } else {

    }

    emily.talk(`Damn... I guess I'll have to find someone else.`);
    ann.talk(`We don't need to be there until this evening.`);
    emily.talk(`Great! So you are free!`);
    mc.talk(`What did you have in mind?`);
    emily.talk(`Guess.`);
    mc.talk(`Oh no.`);
    mc.talk(`Don't tell me you wanna go shopping.`);
    emily.talk(`Exactly!`);
    mc.talk(`I don't wanna sound rude, but why would I wanna do that?`);
    emily.talk(`Because I'm your ${emily.properties.relation} and you missed me and you wanna spend some time with me.`);
    mc.talk(`Mmm...`);
    emily.talk(`And I'll give you my car if you'll come! Anytime you want.`);
    mc.talk(`Deal!`);
    emily.talk(`Ok, so I'll be in my room, tell me when to go and get ready.`);
    mc.talk(`Sure.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_11);
    emily.talk(`Nice to meet you Ann!`);
    ann.talk(`You too.`);
    emily.talk(`You know what?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_13);
    emily.talk(`All three of us should go out sometime! I would love to get to know you.`);
    ann.talk(`Yeah sure.`);
    emily.talk(`Don't worry! I'll wear decent clothes. Haha.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_12);
    emily.talk(`Anyway, I won't disturb you anymore.`);
    return jump(V6AnnArrivedLivingRoom_3, "V6AnnArrivedLivingRoom_3");
};

export const V6AnnArrivedLivingRoom_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15, { transition: true });
    ann.talk(`Wow...`);
    ann.talk(`She is... Something else.`);
    mc.talk(`Wait. Don't you like her?`);
    ann.talk(`Don't get me wrong! She is cute and I bet she is awesome.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_6);
    ann.talk(`But that interaction was something I'm not used to.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15);
    ann.talk(`I can elaborate if you want...`);
    mc.talk(`Go ahead.`);
    ann.talk(`I know she is your ${emily.properties.relation} and all but the way she walked out of her room was... Too much for me.`);
    ann.talk(`And she was like "Hey I know you" and right off the bat suggested that all three of us go out.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_6);
    ann.talk(`Now that I listen to the words coming out of my mouth I realize how stupid that sounds.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15);
    mc.talk(`You feel what you feel, I can't argue with that.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Thanks. I appreciate it.`);
    ann.talk(`But again, don't think that I don't like her or anything.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`I know you don't.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Ok, great.`);
    ann.talk(`I'll go study at the library now.`);
    mc.talk(`How is it going by the way? I forgot to ask.`);
    ann.talk(`It's going great! I feel like I'm learning a lot.`);
    ann.talk(`I just hope I'm making the right decision.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_3);
    mc.talk(`Having second thoughts?`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_6);
    ann.talk(`I don't know... I mean, that's what I wanted to do since I was a child... But maybe it was a child's dream. I don't know... I'll have to think about it.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_15);
    mc.talk(`Isn't it too late?`);
    ann.talk(`I'll continue studying for now and will try to see if I'll get into that college I wanted...`);
    ann.talk(`I can always say I've changed my mind...`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_4);
    mc.talk(`Sounds like a plan.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Yeah...`);
    ann.talk(`Ok, I need to get going now.`);

    ann.talk(`You can come by the library and say hello once you are done with Emily if you want to. Hehe.`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_3);
    mc.talk(`I might just do that!`);
    ImageClass.setImage(images.v6.AnnArrivedNewOutfit_5);
    ann.talk(`Bye ${mc.name}.`);
    doWaitImageByTime(images.v6.AnnArrivedNewOutfit_14);
    ann.talk(`MUAH!`, { style: { overlay: false } });

    return jump(V6AnnArrivedAfter, "V6AnnArrivedAfter");
};